import { Component, Host, h, Prop, Watch, Element, Event, EventEmitter } from '@stencil/core';
import { isMagnoliaEditingMode } from '../../../../helper';

@Component({
  tag: 'ui-cms-grid-element',
  styleUrls: { default: 'ui-cms-grid-element.scss', editing: 'ui-cms-grid-element-magnolia.scss' },
})
export class UiCmsGridElement {
  @Element() el: HTMLElement;

  @Prop({
    reflect: true,
  })
  columns = 12;

  @Prop({
    reflect: true,
  })
  hideSeparator = false;

  /** only works in 8 & 10 column grid */
  @Prop({
    reflect: true,
  })
  centered = false;

  @Prop({
    reflect: true,
  })
  offset = 0;

  @Event() gridReady: EventEmitter;

  @Watch('columns')
  @Watch('centered')
  onColumnsChange(newValue: number) {
    this.el.style.setProperty('--grid-element-span', newValue.toString());
    if (this.centered && (this.columns === 8 || this.columns === 10)) {
      this.el.style.setProperty('--start-column', ((12 - this.columns) / 2 + 1).toString());
    }

    this.gridReady.emit();
  }

  componentDidLoad() {
    this.onColumnsChange(this.columns);
    if (isMagnoliaEditingMode()) {
      this.reorderMgnlEditorBars();
    }
  }

  /**
   * Magnolia editor bars have to be reordered in order to be displayed correctly.
   * One reason for this is that each item (except the first element) gets a margin-top.
   * Since the editor bars are rendered as siblings of the slot elements, they disrupt the layout.
   * This function moves the editor bars to the correct position.
   *
   * A more sustainable solution is described in the following ticket: https://jira.apps.union-investment.de/browse/PB2B-14630
   */
  private reorderMgnlEditorBars(): void {
    let count = 0;
    const checkForEditorBars = () => {
      if (this.el.querySelector('.mgnlEditorBar.start')) {
        clearInterval(intervalID);
        import('./reorder-mgnl-editor-bars').then((module) => {
          module.reorderMgnlEditorBars(this.el);
        });
      }
      count += 1;
      if (count > 10) {
        clearInterval(intervalID);
      }
    };
    const intervalID = setInterval(checkForEditorBars, 200);
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
